export default ({ store, route }) => {
    const meta = route.meta.reduce(
        (meta, routeMeta) => ({ ...meta, ...routeMeta }), // collect all metas for nested routes
        {}
    )
    store.dispatch("meta/setMeta", meta)
}
